module.exports = __webpack_public_path__ + "img/share-sell-light.3bfe52a.svg";